import { Maybe, ICarrierBidSourceTypes } from 'types/graphqlTypes'

export const isDigitalOption = (source: Maybe<ICarrierBidSourceTypes>): boolean => {
  if (!source) {
    return false
  }
  return [ICarrierBidSourceTypes.fleet_planner, ICarrierBidSourceTypes.mobile].includes(source)
}
